/**
 * Custom HugeRTE Preview Plugin
 * Avoids 404 errors by copying styles from editor document instead of loading external CSS
 */

const registerCustomPreviewPlugin = (editor, customStylesCallback) => {
  // Register custom preview command
  editor.addCommand('mcePreview', () => {
    openCustomPreview(editor, customStylesCallback)
  })

  // Register UI elements (button and menu item)
  editor.ui.registry.addButton('preview', {
    icon: 'preview',
    tooltip: 'Preview',
    onAction: () => editor.execCommand('mcePreview')
  })

  editor.ui.registry.addMenuItem('preview', {
    icon: 'preview',
    text: 'Preview',
    onAction: () => editor.execCommand('mcePreview')
  })
}

const getCustomPreviewHtml = (editor, customStylesCallback) => {
  let headHtml = ''
  const encode = editor.dom.encode

  // Add base href
  headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">'

  // Instead of loading external CSS, get all styles from editor document
  const editorDoc = editor.getDoc()
  const editorStyles = editorDoc.querySelectorAll('style')

  editorStyles.forEach(styleElement => {
    headHtml += '<style type="text/css">' + styleElement.textContent + '</style>'
  })

  // Add custom styles if callback provided
  if (customStylesCallback) {
    const customStyles = customStylesCallback()
    if (customStyles) {
      headHtml += '<style type="text/css">' + customStyles + '</style>'
    }
  }

  // Add base content styles
  headHtml += `<style type="text/css">
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      font-size: 14px;
      line-height: 1.6;
      color: #333;
      margin: 8px;
    }
  </style>`

  const bodyId = editor.options.get('body_id') || 'hugerte'
  const bodyClass = editor.options.get('body_class') || ''

  // Prevent clicks script (from original plugin)
  const isMetaKeyPressed = hugerte.Env.os.isMacOS() || hugerte.Env.os.isiOS() ? 'e.metaKey' : 'e.ctrlKey && !e.altKey'
  const preventClicksOnLinksScript = '<script>' +
    'document.addEventListener && document.addEventListener("click", function(e) {' +
    'for (var elm = e.target; elm; elm = elm.parentNode) {' +
    'if (elm.nodeName === "A" && !(' + isMetaKeyPressed + ')) {' +
    'e.preventDefault();' +
    '}' +
    '}' +
    '}, false);' +
    '</script> '

  const directionality = editor.getBody().dir
  const dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : ''

  return '<!DOCTYPE html>' +
    '<html>' +
    '<head>' + headHtml + '</head>' +
    '<body id="' + encode(bodyId) + '" class="mce-content-body ' + encode(bodyClass) + '"' + dirAttr + '>' +
    editor.getContent() +
    preventClicksOnLinksScript +
    '</body>' +
    '</html>'
}

const openCustomPreview = (editor, customStylesCallback) => {
  const content = getCustomPreviewHtml(editor, customStylesCallback)

  const dataApi = editor.windowManager.open({
    title: 'Preview',
    size: 'large',
    body: {
      type: 'panel',
      items: [{
        name: 'preview',
        type: 'iframe',
        sandboxed: true,
        transparent: false
      }]
    },
    buttons: [{
      type: 'cancel',
      name: 'close',
      text: 'Close',
      primary: true
    }],
    initialData: { preview: content }
  })

  dataApi.focus('close')
}

export { registerCustomPreviewPlugin }